import React from 'react'
import * as am4core from '@amcharts/amcharts4/core'
import am4themes_animated from '@amcharts/amcharts4/themes/animated'

import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'

import { Counter } from './Counter'
am4core.useTheme(am4themes_animated)

const App: React.FunctionComponent = () => {
  return (
    <>      
      <Counter />
    </>
  )
}

export default App
